import { useEffect, useState } from 'react';
import { updateInFBDB } from '../../../services/fbdb.data';
import BannerInHtmlPersonaNudge from '../PersonaNudgeComponent/BannerInHtmlPersonaNudge';
import FirstTimePersonaNudge from '../PersonaNudgeComponent/FirstTimePersonaNudge';
import HTMLEmbeddingNudge from '../PersonaNudgeComponent/HTMLEmbeddingPersonaNudge';
import LeadCapturedPersonaNudge from '../PersonaNudgeComponent/LeadCapturedPersonaNudge/LeadCapturedPersonaNudge';
import ReturningPersonaNudge from '../PersonaNudgeComponent/ReturningPersonaNudge';

const NudgeWrapper = ({ userPersonaTypes = [], usersNudgeData = {}, isLoading, user }) => {
    // console.log("userPersonaTypes, usersNudgeData", userPersonaTypes, usersNudgeData);

    const [userPersonas, setUserPersonas] = useState(userPersonaTypes)

    useEffect(() => {
        setUserPersonas(userPersonaTypes)
    }, [userPersonaTypes])


    const handleSaveUserPersonas = () => {
        // console.log("Final UserPersonas", userPersonas)
        let key = `${user}/customise_nudge/`
        updateInFBDB(key, { userPersonaTypes: userPersonas })
    }

    return (
        <div className='nudge__wrapper flex flex-col items-center gap-8 mx-4 sm:gap-14 px-0 sm:px-6 '>
            {
                userPersonaTypes.map((nudge, index) => {
                    const nudgeData = (usersNudgeData && usersNudgeData[nudge.optionValue]) ? usersNudgeData[nudge.optionValue] : {};

                    // const globalData = globalNudgeData[nudge.optionValue] ? globalNudgeData[nudge.optionValue] : {};
                    // check if nudgeData is empty

                    if (Object.keys(nudgeData).length === 0) {
                        return null;
                    }
                    // render component based on cases
                    let temp_nudge_type = nudge.optionValue;

                    // console.log("nudge", nudgeData)
                    if (temp_nudge_type.includes('firstTimePersonaNudge')) {
                        return (
                            <FirstTimePersonaNudge
                                key={index}
                                nudgeData={nudgeData}
                                nudgeId={index + 1}
                                isLoading={isLoading.loading}
                                user={user}
                                nudgeText={nudge}
                                userPersonas={userPersonas}
                                setUserPersonas={setUserPersonas}
                                userPersonaKey={temp_nudge_type}
                                handleSaveUserPersonas={handleSaveUserPersonas}
                            />
                        )
                    }
                    else if (temp_nudge_type.includes('returningPersonaNudge')) {
                        return (
                            <ReturningPersonaNudge
                                key={index}
                                nudgeData={nudgeData}
                                nudgeId={index + 1}
                                isLoading={isLoading.loading}
                                user={user}
                                nudgeText={nudge}
                                userPersonas={userPersonas}
                                setUserPersonas={setUserPersonas}
                                userPersonaKey={temp_nudge_type}
                                handleSaveUserPersonas={handleSaveUserPersonas}
                            />
                        )
                    }
                    else if (temp_nudge_type.includes('leadCapturePersonaNudge')) {
                        return (
                            <LeadCapturedPersonaNudge
                                key={index}
                                nudgeData={nudgeData}
                                nudgeId={index + 1}
                                isLoading={isLoading.loading}
                                user={user}
                                nudgeText={nudge}
                                userPersonas={userPersonas}
                                setUserPersonas={setUserPersonas}
                                userPersonaKey={temp_nudge_type}
                                handleSaveUserPersonas={handleSaveUserPersonas}
                            />
                        )
                    }
                    else if (temp_nudge_type.includes('bannerInHtml')) {
                        return (
                            <BannerInHtmlPersonaNudge
                                key={index}
                                nudgeData={nudgeData}
                                nudgeId={index + 1}
                                isLoading={isLoading.loading}
                                user={user}
                                nudgeText={nudge}
                                userPersonas={userPersonas}
                                setUserPersonas={setUserPersonas}
                                userPersonaKey={temp_nudge_type}
                                handleSaveUserPersonas={handleSaveUserPersonas}
                            />
                        )
                    }
                    else if (temp_nudge_type.includes('htmlEmbedding')) {
                        return (
                            <HTMLEmbeddingNudge
                                key={index}
                                nudgeData={nudgeData}
                                nudgeId={index + 1}
                                isLoading={isLoading.loading}
                                user={user}
                                nudgeText={nudge}
                                userPersonas={userPersonas}
                                setUserPersonas={setUserPersonas}
                                userPersonaKey={temp_nudge_type}
                                handleSaveUserPersonas={handleSaveUserPersonas}
                            />
                        )
                    }
                    else {
                        return null
                    }
                })
            }
        </div>
    )
}

export default NudgeWrapper